import React from 'react';
import { stats } from '../data/mock';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const ValueSection = () => {
  const valueStats = [
    { value: stats.clients, label: 'Clients' },
    { value: stats.projects, label: 'Projects' },
    { value: stats.satisfaction, label: 'Satisfaction' },
    { value: stats.support, label: 'Support' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative z-10">
              <img
                src="https://images.unsplash.com/photo-1460925895917-afdab827c52f"
                alt="Analytics and value"
                className="rounded-3xl shadow-2xl shadow-purple-900/50 w-full h-auto object-cover border border-purple-500/20"
              />
            </div>
            {/* Decorative circles */}
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-purple-600/30 rounded-full opacity-50 -z-10 blur-2xl"></div>
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-blue-600/30 rounded-full opacity-50 -z-10 blur-2xl"></div>
          </div>

          {/* Right Content */}
          <div className="space-y-8 order-1 lg:order-2">
            <div>
              <h2
                className="text-4xl sm:text-5xl font-bold text-white mb-6"
                style={{ letterSpacing: '0.08em' }}
              >
                Delivering Value With Every Solution
              </h2>
              <p className="text-lg text-gray-400">
                At Invotage, we're committed to delivering cutting-edge technology solutions that drive measurable success. From Fortune 500 companies to ambitious startups, we partner with businesses to create digital experiences that captivate audiences and accelerate growth.
              </p>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-6">
              {valueStats.map((stat, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 shadow-lg shadow-purple-900/30 hover:shadow-purple-900/50 transition-shadow border border-purple-500/20"
                >
                  <h3 className="text-4xl font-bold bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent mb-2">{stat.value}</h3>
                  <p className="text-gray-400 font-medium">{stat.label}</p>
                </div>
              ))}
            </div>

            <Link to="/contact">
              <Button className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-6 py-6 rounded-full group shadow-lg shadow-purple-500/50">
                Start Your Project Today
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueSection;